module.exports = __webpack_public_path__ + "img/assistantAccount-home-warp3-img4.1df50078.png";